import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class LabeledStatementCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.LabeledStatement;
    }
    visitNode(sb, node, _options) {
        sb.context.reportUnsupported(node);
    }
}

//# sourceMappingURL=LabeledStatementCompiler.js.map
